import { z, isoZ } from 'my-zod'
import { currencyEnum } from '../../internal/currency'

export const customerOrderPaymentsModel = z.object({
  id: z.string().uuid(),
  paymentAmount: z.number(),
  paymentCurrency: currencyEnum,
  customerOrderId: z.string().uuid(),
  billingServiceId: z.string().nullable(),
  billingServiceStatus: z.string().nullish(),
  creditEventId: z.number().nullable(),
  createdDate: isoZ.instant()
})

export type customerOrderPaymentsModel = z.infer<typeof customerOrderPaymentsModel>
